<template>
  <div class="card shadow-sm">
    <div class="d-flex w-100 p-3 justify-content-between mt-1 border-bottom position-relative card-title-ido">
      <h5 class="fw-bold text-primary">最新需求</h5>
      <a href="#" class="card-link text-primary" @click="more">更多</a>
    </div>
    <div class="list-box mt-2 d-flex align-items-center justify-content-center" v-if="loading || (!loading && list.length<=0)">
      <!-- loading-->
      <div v-if="loading"  class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <!--              暂无数据-->
      <div v-if="!loading && list.length<=0" class="text-secondary fw-bold" role="status">
        <span >暂无数据</span>
      </div>
    </div>
    <div class="list-box mt-2" v-else>
      <!--              数据-->
      <div class="d-flex w-100 py-2 px-3 justify-content-between flex-shrink-0" v-for="(item,index) of list" :key="index">
        <div class="me-4 point-curser list-des fw-medium" @click="goDetail(item)">
          {{item.Title}}</div>
        <div class="text-body-secondary  list-time ">{{item.date}}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {onMounted, ref,computed,defineProps} from "vue";
import router from "@/router";
import {useStore} from 'vuex'
const store = useStore()
const list = computed(()=> store.state.homeModel.latest_demand)//最新需求
defineProps({
  loading:{
    default:true
  }
})
const more = () => {
  router.push({path:'/supplysndsemand'})
}
const goDetail = (item)=>{
  router.push({path:'/demmandDetail',query:{id:item.ID}})

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/css/FirstPageListStyle.scss";
</style>
